var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.992188,
    y: 3.75781,
    width: 14,
    height: 10.2814,
    rx: 3,
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94141 2.82758C2.94141 2.29825 3.37051 1.86914 3.89984 1.86914H12.1199C12.6492 1.86914 13.0783 2.29825 13.0783 2.82758H2.94141Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0508 10.1373L8.30509 11.8828C8.14887 12.0391 7.89558 12.0391 7.73936 11.8828L5.99364 10.1373C5.83742 9.98105 5.83742 9.72778 5.99364 9.57157C6.14987 9.41536 6.40315 9.41536 6.55937 9.57157L7.62219 10.6343L7.62219 6.40003C7.62219 6.1791 7.80129 6 8.02222 6C8.24315 6 8.42225 6.1791 8.42225 6.40003L8.42225 10.6343L9.48508 9.57157C9.6413 9.41536 9.89458 9.41536 10.0508 9.57157C10.207 9.72778 10.207 9.98105 10.0508 10.1373Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.b5fde567a5dfcf3299d86492945127f9.svg";
export { ForwardRef as ReactComponent };